import { DAY_LIST } from 'config/constants'
import { PeriodTime } from 'models/groups'

export const periodTimeHandler = (periodTime: PeriodTime[]): PeriodTime[] => {
  return !periodTime.length ? [{ from: '00:00', to: '23:59', dayOfWeek: DAY_LIST.map(day => day.value) }] : periodTime
}
